import { ChecklistRepository } from "../../repositories/ChecklistRepository";

export class DeleteAttachmentUseCase {
  constructor(private repository: ChecklistRepository) {}

  async execute(attachmentId: number): Promise<void> {
    return await this.repository.deleteAttachment(attachmentId);
  }
}

